import React from 'react';
import {useFlexLayout, useRowSelect, useSortBy, useTable} from 'react-table';


const IndeterminateComponent = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return (
            <>
                <input id={'radio-' + rest.rowid} type="radio" ref={resolvedRef} {...rest} className="tw-w-20px" />
            </>
        );
    }
);
IndeterminateComponent.displayName = 'IndeterminateComponent';

export function SimpleTable({ columns, data, setSelectedDataFn, tableMaxHeight= '600px' }) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            autoResetSelectedRows: false,
            stateReducer: (newState, action) => {
                if (action.type === 'toggleRowSelected') {
                    newState.selectedRowIds = {
                        [action.id]: true
                    };
                }
                return newState;
            }
        },
        useFlexLayout,
        useSortBy,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [{
                id: 'selection',
                disableResizing: true,
                width: 25,
                Cell: ({ row }) => { // eslint-disable-line
                    return (
                        <div>
                            <IndeterminateComponent rowid={row.id}
                                {...row.getToggleRowSelectedProps()}
                                onClick={() => {
                                    setSelectedDataFn(row.original);
                                }}
                            />
                        </div>
                    )
                }
            },
            ...columns
            ]);
        });

    // Render the UI for Picker Table
    return (
        <>
            <div id="simple-table-container" className="tw-w-full tw-h-full tw-max-h-full tw-overflow-y-auto tw-overflow-x-hidden tw-p-12" style={{maxHeight: tableMaxHeight}}>
                <table {...getTableProps()} className="tw-w-full tw-text-gray-700 tw-text-14px tw-bg-white tw-border-gray-300 tw-border-solid">
                    <thead>
                        {headerGroups.map((headerGroup, hIndex) => (
                            <tr {...headerGroup.getHeaderGroupProps()} key={hIndex}>
                                {headerGroup.headers.map((column, cIndex) => (
                                    <th id={'col-' + cIndex} {...column.getHeaderProps(column.getSortByToggleProps())} key={cIndex} className="tw-font-normal tw-border-b tw-border-t tw-m-0 tw-p-12">
                                        <span id={'sort-btn-' + cIndex} className="tw-float-right">
                                            {/* istanbul ignore next */
                                                column.isSorted ? (
                                                    column.isSortedDesc ? (
                                                        ' \u25BC'
                                                    ) : (
                                                        ' \u25B2'
                                                    )
                                                ) : (
                                                    '  '
                                                )
                                            }
                                        </span>
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="tw-w-full">
                        {rows.map((row, rIndex) => {
                            prepareRow(row);
                            return (
                                <tr id={'row-' + rIndex} {...row.getRowProps()} key={rIndex} className="tw-border-b">
                                    {row.cells.map((cell, cIndex) => {
                                        return (
                                            <td {...cell.getCellProps()} key={cIndex} className="last:tw-border-r-0 tw-p-12">
                                                {cell.render('Cell')}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
}

SimpleTable.displayName = 'SimpleTable';
export default SimpleTable;
